import { render } from "./TimelineInfoDetailsOrder.vue?vue&type=template&id=f8f59bb2"
import script from "./TimelineInfoDetailsOrder.vue?vue&type=script&lang=js"
export * from "./TimelineInfoDetailsOrder.vue?vue&type=script&lang=js"

import "./TimelineInfoDetailsOrder.vue?vue&type=style&index=0&id=f8f59bb2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTimeline,QTimelineEntry});
